import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import PropTypes from 'prop-types';
import MessageContainer from './MessageContainer';
import WarningNotice from './WarningNotice';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const I18N_PREFIX = 'knowledgeContentUI.importArticles.panel';
const Cancelled = ({
  alteredArticlesListLink,
  autoPublishEnabled,
  count,
  importedArticleCount,
  totalArticleCount
}) => {
  const showWarningNotice = count > 0 && alteredArticlesListLink;
  const messageKey = autoPublishEnabled ? 'publishedImportMessage' : 'draftImportMessage';
  return /*#__PURE__*/_jsxs(View, {
    marginBlock: showWarningNotice ? '500' : '700',
    children: [/*#__PURE__*/_jsx(MessageContainer, {
      alignItems: "center",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `${I18N_PREFIX}.importCancelled.${messageKey}`,
        options: {
          imported: importedArticleCount,
          count: totalArticleCount
        }
      })
    }), showWarningNotice && /*#__PURE__*/_jsx(WarningNotice, {
      count: count,
      alteredArticlesListLink: alteredArticlesListLink
    })]
  });
};
Cancelled.propTypes = {
  // @ts-expect-error there's no way to allow undefined but disallow null in prop-types
  alteredArticlesListLink: PropTypes.shape({
    url: PropTypes.string
  }),
  autoPublishEnabled: PropTypes.bool.isRequired,
  count: PropTypes.number.isRequired,
  importedArticleCount: PropTypes.number.isRequired,
  totalArticleCount: PropTypes.number.isRequired
};
export default Cancelled;